import {TWITTER, VK, TG} from "./links";

export default Object.freeze({
    [TWITTER]: 'twitter',
    [VK]: 'vk',
    [TG]: 'tg',
});
